// extracted by mini-css-extract-plugin
export var hiddenPrint = "utilities-module--hidden-print--cvB+z";
export var visuallyHidden = "utilities-module--visually-hidden--jHp-E";